import { render, staticRenderFns } from "./ShowActivityDetailsUser.vue?vue&type=template&id=158d7fa8&"
import script from "./ShowActivityDetailsUser.vue?vue&type=script&lang=js&"
export * from "./ShowActivityDetailsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports